import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export class Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export class AffirmativeAgreementDashboardResult {
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export class AuthInput {
  code: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  redirectUri: Scalars['String'];
};

export class AuthType {
  token: Scalars['String'];
  user: User;
};

export class ColorRaceDashboardResult {
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export class Country {
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userCreated?: Maybe<User>;
  userDeleted?: Maybe<User>;
  userUpdated?: Maybe<User>;
};

export class CreateCountryInput {
  code: Scalars['String'];
  name: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
};

export class CreateNotificationInput {
  message?: InputMaybe<Scalars['String']>;
  relationId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export class CreateSolicitationInput {
  applicantMP?: InputMaybe<Scalars['String']>;
  codeMP?: InputMaybe<Scalars['String']>;
  costCenter: Scalars['String'];
  countryId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  isPcd?: InputMaybe<Scalars['Boolean']>;
  jobRoleId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  observation?: InputMaybe<Scalars['String']>;
  re: Scalars['String'];
  terminationDate: Scalars['DateTime'];
  terminationReasonId: Scalars['String'];
  unityId?: InputMaybe<Scalars['String']>;
};

export class CreateUnityInput {
  countryId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  status: Scalars['String'];
};

export class CreateUserInput {
  costCenter: Scalars['String'];
  email: Scalars['String'];
  gender: Scalars['String'];
  jobRoleId: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  profile: Scalars['String'];
  re: Scalars['String'];
  scopeCostCenters?: InputMaybe<Array<Scalars['String']>>;
  scopeJobRoleIds?: InputMaybe<Array<Scalars['String']>>;
  scopeUnityIds?: InputMaybe<Array<Scalars['String']>>;
  status: Scalars['String'];
  unityId: Scalars['String'];
};

export class DefaultMessage {
  message: Scalars['String'];
  status: Scalars['Int'];
};

export class EnumType {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export class GenderCategory {
  cisgender?: Maybe<Scalars['Int']>;
  transgender?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export class GenderIdentityDashboardResult {
  man: GenderCategory;
  nonBinary?: Maybe<Scalars['Float']>;
  woman: GenderCategory;
};

export class ImportFile {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  importId: Scalars['String'];
  importType: Scalars['String'];
  originalName: Scalars['String'];
  urlFile: Scalars['String'];
  userCreated?: Maybe<User>;
};

export class InvoluntaryDashboardResult {
  percentage?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export class JobRole {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  solicitation?: Maybe<Array<Solicitation>>;
  updatedAt: Scalars['DateTime'];
  user: JobRole;
};

export class Mutation {
  /** Create new Country */
  createCountry: Country;
  createNotification: DefaultMessage;
  createSolicitation: Solicitation;
  /** Create new Unity */
  createUnity: Unity;
  /** Create new User */
  createUser: User;
  /** Delete All User notifications */
  deleteAllNotifications: DefaultMessage;
  /** Delete Country by Id */
  deleteCountry: DefaultMessage;
  /** Remove Notification By Id */
  deleteNotification: DefaultMessage;
  /** Remove Solicitation By Id */
  deleteSolicitation: DefaultMessage;
  /** Delete Unity by Id */
  deleteUnity: DefaultMessage;
  /** Delete User by Id */
  deleteUser: DefaultMessage;
  login: AuthType;
  /** Read All User notifications */
  readAllNotifications: DefaultMessage;
  /** Read User notification */
  readNotification: DefaultMessage;
  /** Resend e-mail termination form */
  resendTerminationForm: DefaultMessage;
  /** Save solicitation in hr-opinion Step */
  saveHrOpinionStep: DefaultMessage;
  /** save Termination Form Answers */
  saveTerminationFormAnswers: DefaultMessage;
  /** Send to completed solicitation in hr-opinion Step */
  sendCompletedHrOpinionStep: DefaultMessage;
  /** Send In Not Initiated Step */
  sendNotInitiatedStep: DefaultMessage;
  /** Update Country By Id */
  updateCountry: Country;
  /** Update Solicitation */
  updateSolicitation: Solicitation;
  /** Update Unity By Id */
  updateUnity: Unity;
  /** Update User by Id */
  updateUser: User;
};


export class MutationCreateCountryArgs {
  data: CreateCountryInput;
};


export class MutationCreateNotificationArgs {
  data: CreateNotificationInput;
};


export class MutationCreateSolicitationArgs {
  data: CreateSolicitationInput;
};


export class MutationCreateUnityArgs {
  data: CreateUnityInput;
};


export class MutationCreateUserArgs {
  data: CreateUserInput;
};


export class MutationDeleteCountryArgs {
  id: Scalars['String'];
};


export class MutationDeleteNotificationArgs {
  notificationId: Scalars['String'];
};


export class MutationDeleteSolicitationArgs {
  id: Scalars['String'];
};


export class MutationDeleteUnityArgs {
  id: Scalars['String'];
};


export class MutationDeleteUserArgs {
  id: Scalars['String'];
};


export class MutationLoginArgs {
  data: AuthInput;
};


export class MutationReadNotificationArgs {
  notificationId: Scalars['String'];
};


export class MutationResendTerminationFormArgs {
  solicitationId: Scalars['String'];
};


export class MutationSaveHrOpinionStepArgs {
  data: SaveHrOpinionStepInput;
};


export class MutationSaveTerminationFormAnswersArgs {
  data: Array<TerminationFormAnswerDto>;
  origin: Scalars['String'];
  solicitationId: Scalars['String'];
};


export class MutationSendCompletedHrOpinionStepArgs {
  data: SaveHrOpinionStepInput;
};


export class MutationSendNotInitiatedStepArgs {
  data: SendNotInitiatedStepInput;
};


export class MutationUpdateCountryArgs {
  data: UpdateCountryInput;
};


export class MutationUpdateSolicitationArgs {
  data: UpdateSolicitationInput;
};


export class MutationUpdateUnityArgs {
  data: UpdateUnityInput;
};


export class MutationUpdateUserArgs {
  data: UpdateUserInput;
};

export class NotificationDto {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  message: Scalars['String'];
  readAt?: Maybe<Scalars['DateTime']>;
  relationId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class NpsDashboardResult {
  valueNPS?: Maybe<Scalars['Int']>;
};

export class PcdDashboardResult {
  qtdIsNotPCD?: Maybe<Scalars['Int']>;
  qtdIsPCD?: Maybe<Scalars['Int']>;
};

export class Query {
  affirmativeAgreementDashboard: Array<AffirmativeAgreementDashboardResult>;
  colorRaceDashboard: Array<ColorRaceDashboardResult>;
  /** List All Countries */
  countries: Array<Country>;
  /** Return Country By ID */
  countryById: Country;
  /** Return User Logged */
  currentUser: User;
  /** Return All By Type */
  enumByType: Array<EnumType>;
  /** Return Enum Type by Id */
  enumTypeById: EnumType;
  /** Return All Enum Types */
  enumTypes: Array<EnumType>;
  fetchEmailsSap: Scalars['Boolean'];
  genderIdentityDashboard: GenderIdentityDashboardResult;
  /** Return Termination Form Question with answers */
  getTerminationForm: TerminationFormDto;
  /** Return All Import File by Type */
  importFileByType: Array<ImportFile>;
  involuntaryDashboard: Array<InvoluntaryDashboardResult>;
  /** Return JobRole By ID */
  jobRoleById: JobRole;
  /** List All Job Roles */
  jobRoles: Array<JobRole>;
  /** List All Unity */
  listUnity: Array<Unity>;
  /** Return All Notification By User */
  notificationsByUser: UserNotificationDto;
  npsDashboard: NpsDashboardResult;
  pcdSolicitationsDashboard: PcdDashboardResult;
  /** Return All Solicitation Cards */
  searchAllSolicitationCards: SolicitationStepGroupedDto;
  /** Return All Solicitation Lists */
  searchAllSolicitationList: SolicitationPage;
  /** Return Solicitation By ID */
  solicitationById: Solicitation;
  /** Return Termination Reason By ID */
  terminationReasonById: TerminationReason;
  /** List All Termination Reason */
  terminationReasons: Array<TerminationReason>;
  /** Return all unities paged */
  unities: UnityPage;
  /** Return Unity by Id */
  unity: Unity;
  /** Return User By Id */
  user: User;
  /** Return All users paged */
  users: UserPage;
  /** Return All users by profile */
  usersByProfile: Array<User>;
  /** Valid expiration token by termination form */
  validTokenTerminationForm: TerminationFormDto;
  voluntaryDashboard: Array<VoluntaryDashboardResult>;
};


export class QueryAffirmativeAgreementDashboardArgs {
  data: SearchDashboardInput;
};


export class QueryColorRaceDashboardArgs {
  data: SearchDashboardInput;
};


export class QueryCountryByIdArgs {
  id: Scalars['String'];
};


export class QueryEnumByTypeArgs {
  type: Scalars['String'];
};


export class QueryEnumTypeByIdArgs {
  id: Scalars['String'];
};


export class QueryGenderIdentityDashboardArgs {
  data: SearchDashboardInput;
};


export class QueryGetTerminationFormArgs {
  solicitationId: Scalars['String'];
};


export class QueryImportFileByTypeArgs {
  data: SearchImportFileInput;
};


export class QueryInvoluntaryDashboardArgs {
  data: SearchDashboardInput;
};


export class QueryJobRoleByIdArgs {
  id: Scalars['String'];
};


export class QueryNpsDashboardArgs {
  data: SearchDashboardInput;
};


export class QueryPcdSolicitationsDashboardArgs {
  data: SearchDashboardInput;
};


export class QuerySearchAllSolicitationCardsArgs {
  data: SearchSolicitationCardInput;
};


export class QuerySearchAllSolicitationListArgs {
  data: SearchSolicitationListInput;
};


export class QuerySolicitationByIdArgs {
  id: Scalars['String'];
};


export class QueryTerminationReasonByIdArgs {
  id: Scalars['String'];
};


export class QueryUnitiesArgs {
  data: SearchUnityInput;
};


export class QueryUnityArgs {
  id: Scalars['String'];
};


export class QueryUserArgs {
  id: Scalars['String'];
};


export class QueryUsersArgs {
  data: SearchUserInput;
};


export class QueryUsersByProfileArgs {
  profile: Scalars['String'];
};


export class QueryValidTokenTerminationFormArgs {
  expirationToken: Scalars['String'];
};


export class QueryVoluntaryDashboardArgs {
  data: SearchDashboardInput;
};

export class SaveHrOpinionStepInput {
  hrConsiderations?: InputMaybe<Scalars['String']>;
  sendCompliance: Scalars['Boolean'];
  solicitationId: Scalars['String'];
};

export class SearchDashboardInput {
  costCenter?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  terminationReasonType?: InputMaybe<Scalars['String']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class SearchImportFileInput {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<Scalars['String']>;
};

export class SearchSolicitationCardInput {
  countryId?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class SearchSolicitationListInput {
  countryId?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  step?: InputMaybe<Scalars['String']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class SearchUnityInput {
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export class SearchUserInput {
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export class SendNotInitiatedStepInput {
  email?: InputMaybe<Scalars['String']>;
  solicitationId: Scalars['String'];
  terminationDate: Scalars['DateTime'];
};

export class Solicitation {
  acceptTermsOrNotAt?: Maybe<Scalars['DateTime']>;
  answeredTerminationFormAt?: Maybe<Scalars['DateTime']>;
  answeredTerminationFormBy: Scalars['String'];
  applicantMP?: Maybe<Scalars['String']>;
  areaOfActivity?: Maybe<Scalars['String']>;
  codeMP?: Maybe<Scalars['String']>;
  completedSolicitationAt?: Maybe<Scalars['DateTime']>;
  costCenter: Scalars['String'];
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  hrConsiderations?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAcceptTerms: Scalars['Boolean'];
  isAnsweredTerminationForm: Scalars['Boolean'];
  isCompletedHidden: Scalars['Boolean'];
  isNotAcceptTerms: Scalars['Boolean'];
  isPcd: Scalars['Boolean'];
  isSendTerminationFormByEmail: Scalars['Boolean'];
  isUpdatedByEmailSAP: Scalars['Boolean'];
  jobRole?: Maybe<JobRole>;
  name: Scalars['String'];
  observation?: Maybe<Scalars['String']>;
  re: Scalars['String'];
  sendCompliance: Scalars['Boolean'];
  sendInternalConsulting: Scalars['Boolean'];
  signatureCollaboratorUrl?: Maybe<Scalars['String']>;
  signatureHrUrl?: Maybe<Scalars['String']>;
  solicitationExpiration?: Maybe<Array<SolicitationExpiration>>;
  solicitationGeneratedBy: Scalars['String'];
  solicitationHistoryStatus?: Maybe<Array<SolicitationHistoryStatus>>;
  solicitationStep?: Maybe<Array<SolicitationStep>>;
  status?: Maybe<Scalars['String']>;
  step: Scalars['String'];
  terminationDate: Scalars['DateTime'];
  terminationFormSolicitationAnswer?: Maybe<Array<TerminationFormSolicitationAnswer>>;
  terminationReason?: Maybe<TerminationReason>;
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
  userCompleted?: Maybe<User>;
  userCreated?: Maybe<User>;
  userDeleted?: Maybe<User>;
  userUpdated?: Maybe<User>;
};

export class SolicitationExpiration {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  expirationAt?: Maybe<Scalars['DateTime']>;
  expirationType: Scalars['String'];
  id: Scalars['ID'];
  solicitation: Solicitation;
  updatedAt: Scalars['DateTime'];
};

export class SolicitationHistoryStatus {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  solicitation: Solicitation;
  status: Scalars['String'];
};

export class SolicitationPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<Solicitation>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class SolicitationStep {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  solicitation: Solicitation;
  step: Scalars['String'];
};

export class SolicitationStepGroupedDto {
  completed: Array<Solicitation>;
  hrOpinion: Array<Solicitation>;
  notInitiated: Array<Solicitation>;
  terminationForm: Array<Solicitation>;
};

export class TerminationFormAnswerDto {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  questionOrder: Scalars['Float'];
  questionStep: Scalars['Float'];
  terminationFormAnswerText?: InputMaybe<Scalars['String']>;
  terminationFormQuestionAnswer: Array<TerminationFormAnswerOptionDto>;
  text: Scalars['String'];
};

export class TerminationFormAnswerOptionDto {
  answerOrder: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isAnswersSelected: Scalars['Boolean'];
  text: Scalars['String'];
};

export class TerminationFormDto {
  solicitationId?: Maybe<Scalars['String']>;
  terminationFormQuestion: Array<TerminationFormQuestion>;
  userAreaOfActivity?: Maybe<Scalars['String']>;
  userJobRole?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  userRe?: Maybe<Scalars['String']>;
  userTerminationDate?: Maybe<Scalars['DateTime']>;
};

export class TerminationFormQuestion {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  multipleSelection: Scalars['Boolean'];
  questionOrder: Scalars['Float'];
  questionOrderPdf?: Maybe<Scalars['Float']>;
  questionStep: Scalars['Float'];
  terminationFormAnswerText?: Maybe<Scalars['String']>;
  terminationFormQuestionAnswer?: Maybe<Array<TerminationFormQuestionAnswer>>;
  terminationFormSolicitationAnswer?: Maybe<Array<TerminationFormSolicitationAnswer>>;
  text: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class TerminationFormQuestionAnswer {
  answerOrder: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAnswersSelected?: Maybe<Scalars['Boolean']>;
  terminationFormQuestion: TerminationFormQuestion;
  terminationFormSolicitationAnswer?: Maybe<Array<TerminationFormSolicitationAnswer>>;
  text: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class TerminationFormSolicitationAnswer {
  answerText?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  solicitation: Solicitation;
  terminationFormQuestion?: Maybe<TerminationFormQuestion>;
  terminationFormQuestionAnswer?: Maybe<TerminationFormQuestionAnswer>;
  updatedAt: Scalars['DateTime'];
};

export class TerminationReason {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  solicitation?: Maybe<Array<Solicitation>>;
  terminationFormType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class Unity {
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  solicitation?: Maybe<Array<Solicitation>>;
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<Array<User>>;
  userCreated?: Maybe<User>;
  userDeleted?: Maybe<User>;
  userUpdated?: Maybe<User>;
};

export class UnityPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<Unity>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class UpdateCountryInput {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export class UpdateSolicitationInput {
  applicantMP?: InputMaybe<Scalars['String']>;
  codeMP?: InputMaybe<Scalars['String']>;
  costCenter?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isPcd?: InputMaybe<Scalars['Boolean']>;
  jobRoleId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  observation?: InputMaybe<Scalars['String']>;
  re?: InputMaybe<Scalars['String']>;
  sendInternalConsulting?: InputMaybe<Scalars['Boolean']>;
  terminationDate?: InputMaybe<Scalars['DateTime']>;
  terminationReasonId?: InputMaybe<Scalars['String']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class UpdateUnityInput {
  countryId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export class UpdateUserInput {
  costCenter?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  jobRoleId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Scalars['String']>;
  re?: InputMaybe<Scalars['String']>;
  scopeCostCenters?: InputMaybe<Array<Scalars['String']>>;
  scopeJobRoleIds?: InputMaybe<Array<Scalars['String']>>;
  scopeUnityIds?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Scalars['String']>;
  unityId?: InputMaybe<Scalars['String']>;
};

export class User {
  access?: Maybe<Array<UserAccess>>;
  costCenter?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id: Scalars['ID'];
  jobRole?: Maybe<JobRole>;
  name: Scalars['String'];
  phone: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  profile: Scalars['String'];
  re: Scalars['String'];
  scopeCostCenters?: Maybe<Array<Scalars['String']>>;
  scopeJobRoleIds?: Maybe<Array<Scalars['String']>>;
  scopeUnityIds?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  unity?: Maybe<Unity>;
  updatedAt: Scalars['DateTime'];
  userCreated?: Maybe<User>;
  userDeleted?: Maybe<User>;
  userNotification?: Maybe<Array<UserNotification>>;
  userUpdated?: Maybe<User>;
};

export class UserAccess {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  ip: Scalars['String'];
  user: User;
};

export class UserNotification {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  message: Scalars['String'];
  readAt?: Maybe<Scalars['DateTime']>;
  relationId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: User;
};

export class UserNotificationDto {
  notifications?: Maybe<Array<NotificationDto>>;
  total: Scalars['Int'];
  totalUnread: Scalars['Int'];
};

export class UserPage {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previousPage: Scalars['Boolean'];
  results?: Maybe<Array<User>>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class VoluntaryDashboardResult {
  percentage?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type CountryFragment = { id: string, name: string, code: string, status?: string | null, createdAt: any, updatedAt: any };

export type AuthTypeFragment = { token: string, user: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } };

export type UserFragment = { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null };

export type DefaultMessageFragment = { message: string, status: number };

export type SolicitationFragment = { id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null };

export type SolicitationStepGroupedDtoFragment = { notInitiated: Array<{ id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null }>, terminationForm: Array<{ id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null }>, hrOpinion: Array<{ id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null }>, completed: Array<{ id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null }> };

export type SolicitationPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null }> | null };

export type UnityPageFragment = { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, name: string, status?: string | null, countryId?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, user?: Array<{ id: string, name: string }> | null }> | null };

export type UnityFragment = { id: string, name: string, status?: string | null, countryId?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, userCreated?: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } | null, userUpdated?: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } | null, userDeleted?: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } | null, user?: Array<{ id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null }> | null };

export type EnumTypeFragment = { id: string, type: string, value: string, description?: string | null, detail?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null };

export type TerminationFormSolicitationAnswerFragment = { answerText?: string | null, createdAt: any, deletedAt?: any | null, id: string, updatedAt: any };

export type TerminationFormQuestionAnswerFragment = { answerOrder: number, createdAt: any, deletedAt?: any | null, description?: string | null, id: string, isAnswersSelected?: boolean | null, text: string, updatedAt: any };

export type TerminationFormQuestionFragment = { createdAt: any, deletedAt?: any | null, description?: string | null, multipleSelection: boolean, id: string, questionOrder: number, questionStep: number, terminationFormAnswerText?: string | null, text: string, type: string, updatedAt: any, terminationFormQuestionAnswer?: Array<{ answerOrder: number, createdAt: any, deletedAt?: any | null, description?: string | null, id: string, isAnswersSelected?: boolean | null, text: string, updatedAt: any }> | null, terminationFormSolicitationAnswer?: Array<{ answerText?: string | null, createdAt: any, deletedAt?: any | null, id: string, updatedAt: any }> | null };

export type TerminationFormDtoFragment = { userAreaOfActivity?: string | null, userJobRole?: string | null, userName?: string | null, userRe?: string | null, userTerminationDate?: any | null, solicitationId?: string | null, terminationFormQuestion: Array<{ createdAt: any, deletedAt?: any | null, description?: string | null, multipleSelection: boolean, id: string, questionOrder: number, questionStep: number, terminationFormAnswerText?: string | null, text: string, type: string, updatedAt: any, terminationFormQuestionAnswer?: Array<{ answerOrder: number, createdAt: any, deletedAt?: any | null, description?: string | null, id: string, isAnswersSelected?: boolean | null, text: string, updatedAt: any }> | null, terminationFormSolicitationAnswer?: Array<{ answerText?: string | null, createdAt: any, deletedAt?: any | null, id: string, updatedAt: any }> | null }> };

export type UserNotificationDtoFragment = { total: number, totalUnread: number, notifications?: Array<{ id: string, relationId?: string | null, title: string, status?: string | null, message: string, isRead: boolean, readAt?: any | null, createdAt: any, updatedAt: any, deletedAt?: any | null }> | null };

export type JobRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type JobRolesQuery = { jobRoles: Array<{ id: string, name: string }> };

export type ListUnityQueryVariables = Exact<{ [key: string]: never; }>;


export type ListUnityQuery = { listUnity: Array<{ id: string, name: string, countryId?: string | null }> };

export type EnumByTypeQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type EnumByTypeQuery = { enumByType: Array<{ id: string, type: string, value: string, description?: string | null, detail?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null }> };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { countries: Array<{ id: string, name: string, code: string, status?: string | null, createdAt: any, updatedAt: any }> };

export type CountryByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CountryByIdQuery = { countryById: { id: string, name: string, code: string, status?: string | null, createdAt: any, updatedAt: any } };

export type CreateCountryMutationVariables = Exact<{
  input: CreateCountryInput;
}>;


export type CreateCountryMutation = { createCountry: { id: string, name: string, code: string, status?: string | null, createdAt: any, updatedAt: any } };

export type UpdateCountryMutationVariables = Exact<{
  input: UpdateCountryInput;
}>;


export type UpdateCountryMutation = { updateCountry: { id: string, name: string, code: string, status?: string | null, createdAt: any, updatedAt: any } };

export type DeleteCountryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCountryMutation = { deleteCountry: { message: string, status: number } };

export type ColorRaceDashboardQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type ColorRaceDashboardQuery = { colorRaceDashboard: Array<{ type?: string | null, value?: number | null }> };

export type AffirmativeAgreementDashboardQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type AffirmativeAgreementDashboardQuery = { affirmativeAgreementDashboard: Array<{ type?: string | null, value?: number | null }> };

export type TerminationReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type TerminationReasonsQuery = { terminationReasons: Array<{ id: string, name: string, terminationFormType: string }> };

export type VoluntaryDashboardQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type VoluntaryDashboardQuery = { voluntaryDashboard: Array<{ type?: string | null, percentage?: number | null }> };

export type InvoluntaryDashboardQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type InvoluntaryDashboardQuery = { involuntaryDashboard: Array<{ type?: string | null, percentage?: number | null }> };

export type GenderIdentityDashboardQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type GenderIdentityDashboardQuery = { genderIdentityDashboard: { nonBinary?: number | null, man: { type?: string | null, cisgender?: number | null, transgender?: number | null }, woman: { type?: string | null, cisgender?: number | null, transgender?: number | null } } };

export type NpsDashboardQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type NpsDashboardQuery = { npsDashboard: { valueNPS?: number | null } };

export type DashboardPageQueryVariables = Exact<{
  data: SearchDashboardInput;
}>;


export type DashboardPageQuery = { colorRaceDashboard: Array<{ type?: string | null, value?: number | null }>, npsDashboard: { valueNPS?: number | null }, affirmativeAgreementDashboard: Array<{ type?: string | null, value?: number | null }>, voluntaryDashboard: Array<{ type?: string | null, percentage?: number | null }>, involuntaryDashboard: Array<{ type?: string | null, percentage?: number | null }>, genderIdentityDashboard: { nonBinary?: number | null, man: { type?: string | null, cisgender?: number | null, transgender?: number | null }, woman: { type?: string | null, cisgender?: number | null, transgender?: number | null } }, pcdSolicitationsDashboard: { qtdIsNotPCD?: number | null, qtdIsPCD?: number | null } };

export type GetTerminationFormQueryVariables = Exact<{
  solicitationId: Scalars['String'];
}>;


export type GetTerminationFormQuery = { getTerminationForm: { userAreaOfActivity?: string | null, userJobRole?: string | null, userName?: string | null, userRe?: string | null, userTerminationDate?: any | null, solicitationId?: string | null, terminationFormQuestion: Array<{ createdAt: any, deletedAt?: any | null, description?: string | null, multipleSelection: boolean, id: string, questionOrder: number, questionStep: number, terminationFormAnswerText?: string | null, text: string, type: string, updatedAt: any, terminationFormQuestionAnswer?: Array<{ answerOrder: number, createdAt: any, deletedAt?: any | null, description?: string | null, id: string, isAnswersSelected?: boolean | null, text: string, updatedAt: any }> | null, terminationFormSolicitationAnswer?: Array<{ answerText?: string | null, createdAt: any, deletedAt?: any | null, id: string, updatedAt: any }> | null }> } };

export type ValidTokenTerminationFormQueryVariables = Exact<{
  expirationToken: Scalars['String'];
}>;


export type ValidTokenTerminationFormQuery = { validTokenTerminationForm: { userAreaOfActivity?: string | null, userJobRole?: string | null, userName?: string | null, userRe?: string | null, userTerminationDate?: any | null, solicitationId?: string | null, terminationFormQuestion: Array<{ createdAt: any, deletedAt?: any | null, description?: string | null, multipleSelection: boolean, id: string, questionOrder: number, questionStep: number, terminationFormAnswerText?: string | null, text: string, type: string, updatedAt: any, terminationFormQuestionAnswer?: Array<{ answerOrder: number, createdAt: any, deletedAt?: any | null, description?: string | null, id: string, isAnswersSelected?: boolean | null, text: string, updatedAt: any }> | null, terminationFormSolicitationAnswer?: Array<{ answerText?: string | null, createdAt: any, deletedAt?: any | null, id: string, updatedAt: any }> | null }> } };

export type SaveTerminationFormAnswersMutationVariables = Exact<{
  data: Array<TerminationFormAnswerDto> | TerminationFormAnswerDto;
  solicitationId: Scalars['String'];
  origin: Scalars['String'];
}>;


export type SaveTerminationFormAnswersMutation = { saveTerminationFormAnswers: { message: string, status: number } };

export type NotificationsByUserQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsByUserQuery = { notificationsByUser: { total: number, totalUnread: number, notifications?: Array<{ id: string, relationId?: string | null, title: string, status?: string | null, message: string, isRead: boolean, readAt?: any | null, createdAt: any, updatedAt: any, deletedAt?: any | null }> | null } };

export type ReadNotificationMutationVariables = Exact<{
  notificationId: Scalars['String'];
}>;


export type ReadNotificationMutation = { readNotification: { message: string, status: number } };

export type ReadAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllNotificationsMutation = { readAllNotifications: { message: string, status: number } };

export type DeleteNotificationMutationVariables = Exact<{
  notificationId: Scalars['String'];
}>;


export type DeleteNotificationMutation = { deleteNotification: { message: string, status: number } };

export type DeleteAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllNotificationsMutation = { deleteAllNotifications: { message: string, status: number } };

export type SearchAllSolicitationCardsQueryVariables = Exact<{
  input: SearchSolicitationCardInput;
}>;


export type SearchAllSolicitationCardsQuery = { searchAllSolicitationCards: { notInitiated: Array<{ id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null }>, terminationForm: Array<{ id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null }>, hrOpinion: Array<{ id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null }>, completed: Array<{ id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null }> } };

export type SearchAllSolicitationListQueryVariables = Exact<{
  input: SearchSolicitationListInput;
}>;


export type SearchAllSolicitationListQuery = { searchAllSolicitationList: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null }> | null } };

export type UnitiesQueryVariables = Exact<{
  input: SearchUnityInput;
}>;


export type UnitiesQuery = { unities: { totalCount: number, pageSize: number, currentPage: number, totalPage: number, previousPage: boolean, nextPage: boolean, results?: Array<{ id: string, name: string, status?: string | null, countryId?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, user?: Array<{ id: string, name: string }> | null }> | null } };

export type CreateSolicitationMutationVariables = Exact<{
  input: CreateSolicitationInput;
}>;


export type CreateSolicitationMutation = { createSolicitation: { id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null } };

export type UpdateSolicitationMutationVariables = Exact<{
  input: UpdateSolicitationInput;
}>;


export type UpdateSolicitationMutation = { updateSolicitation: { id: string, codeMP?: string | null, re: string, name: string, applicantMP?: string | null, email?: string | null, costCenter: string, countryId?: string | null, isPcd: boolean, areaOfActivity?: string | null, terminationDate: any, observation?: string | null, step: string, status?: string | null, hrConsiderations?: string | null, signatureCollaboratorUrl?: string | null, signatureHrUrl?: string | null, solicitationGeneratedBy: string, isUpdatedByEmailSAP: boolean, isAnsweredTerminationForm: boolean, sendCompliance: boolean, sendInternalConsulting: boolean, createdAt: any, completedSolicitationAt?: any | null, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, unity?: { id: string, name: string } | null, userCompleted?: { id: string, name: string } | null, terminationReason?: { id: string, name: string, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, jobRole?: { id: string, deletedAt?: any | null, updatedAt: any, createdAt: any, name: string } | null } };

export type DeleteSolicitationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSolicitationMutation = { deleteSolicitation: { message: string, status: number } };

export type SendNotInitiatedStepMutationVariables = Exact<{
  input: SendNotInitiatedStepInput;
}>;


export type SendNotInitiatedStepMutation = { sendNotInitiatedStep: { message: string, status: number } };

export type ResendTerminationFormMutationVariables = Exact<{
  solicitationId: Scalars['String'];
}>;


export type ResendTerminationFormMutation = { resendTerminationForm: { message: string, status: number } };

export type SaveHrOpinionStepMutationVariables = Exact<{
  input: SaveHrOpinionStepInput;
}>;


export type SaveHrOpinionStepMutation = { saveHrOpinionStep: { message: string, status: number } };

export type SendCompletedHrOpinionStepMutationVariables = Exact<{
  input: SaveHrOpinionStepInput;
}>;


export type SendCompletedHrOpinionStepMutation = { sendCompletedHrOpinionStep: { message: string, status: number } };

export type CreateUnityMutationVariables = Exact<{
  input: CreateUnityInput;
}>;


export type CreateUnityMutation = { createUnity: { id: string, name: string, status?: string | null, countryId?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, userCreated?: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } | null, userUpdated?: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } | null, userDeleted?: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } | null, user?: Array<{ id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null }> | null } };

export type UpdateUnityMutationVariables = Exact<{
  input: UpdateUnityInput;
}>;


export type UpdateUnityMutation = { updateUnity: { id: string, name: string, status?: string | null, countryId?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, country?: { id: string, name: string, code: string } | null, userCreated?: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } | null, userUpdated?: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } | null, userDeleted?: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } | null, user?: Array<{ id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null }> | null } };

export type DeleteUnityMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUnityMutation = { deleteUnity: { message: string, status: number } };

export type LoginMutationVariables = Exact<{
  data: AuthInput;
}>;


export type LoginMutation = { login: { token: string, user: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } };

export type UsersQueryVariables = Exact<{
  data: SearchUserInput;
}>;


export type UsersQuery = { users: { currentPage: number, nextPage: boolean, pageSize: number, previousPage: boolean, totalCount: number, totalPage: number, results?: Array<{ id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null }> | null } };

export type CreateUserMutationVariables = Exact<{
  data: CreateUserInput;
}>;


export type CreateUserMutation = { createUser: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } };

export type UpdateUserMutationVariables = Exact<{
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { updateUser: { id: string, name: string, email?: string | null, re: string, phone: string, gender: string, profile: string, status?: string | null, costCenter?: string | null, photoUrl?: string | null, scopeUnityIds?: Array<string> | null, scopeJobRoleIds?: Array<string> | null, scopeCostCenters?: Array<string> | null, createdAt: any, updatedAt: any, deletedAt?: any | null, unity?: { id: string, name: string, countryId?: string | null, country?: { id: string, name: string, code: string } | null } | null, jobRole?: { id: string, name: string } | null, access?: Array<{ id: string, ip: string, createdAt: any, user: { id: string, name: string } }> | null } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteUserMutation = { deleteUser: { message: string, status: number } };

export const CountryFragmentDoc = gql`
    fragment Country on Country {
  id
  name
  code
  status
  createdAt
  updatedAt
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  email
  re
  phone
  gender
  profile
  status
  costCenter
  photoUrl
  scopeUnityIds
  scopeJobRoleIds
  scopeCostCenters
  createdAt
  updatedAt
  deletedAt
  status
  unity {
    id
    name
    countryId
    country {
      id
      name
      code
    }
  }
  jobRole {
    id
    name
  }
  access {
    id
    ip
    createdAt
    user {
      id
      name
    }
  }
}
    `;
export const AuthTypeFragmentDoc = gql`
    fragment AuthType on AuthType {
  token
  user {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const DefaultMessageFragmentDoc = gql`
    fragment DefaultMessage on DefaultMessage {
  message
  status
}
    `;
export const SolicitationFragmentDoc = gql`
    fragment Solicitation on Solicitation {
  id
  codeMP
  re
  name
  applicantMP
  email
  costCenter
  countryId
  country {
    id
    name
    code
  }
  unity {
    id
    name
  }
  isPcd
  areaOfActivity
  terminationDate
  observation
  step
  status
  hrConsiderations
  signatureCollaboratorUrl
  signatureHrUrl
  solicitationGeneratedBy
  isUpdatedByEmailSAP
  isAnsweredTerminationForm
  sendCompliance
  sendInternalConsulting
  createdAt
  userCompleted {
    id
    name
  }
  completedSolicitationAt
  updatedAt
  deletedAt
  terminationReason {
    id
    name
    createdAt
    updatedAt
    deletedAt
  }
  jobRole {
    id
    deletedAt
    updatedAt
    createdAt
    name
  }
}
    `;
export const SolicitationStepGroupedDtoFragmentDoc = gql`
    fragment SolicitationStepGroupedDto on SolicitationStepGroupedDto {
  notInitiated {
    ...Solicitation
  }
  terminationForm {
    ...Solicitation
  }
  hrOpinion {
    ...Solicitation
  }
  completed {
    ...Solicitation
  }
}
    ${SolicitationFragmentDoc}`;
export const SolicitationPageFragmentDoc = gql`
    fragment SolicitationPage on SolicitationPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    ...Solicitation
  }
}
    ${SolicitationFragmentDoc}`;
export const UnityPageFragmentDoc = gql`
    fragment UnityPage on UnityPage {
  totalCount
  pageSize
  currentPage
  totalPage
  previousPage
  nextPage
  results {
    id
    name
    status
    countryId
    country {
      id
      name
      code
    }
    createdAt
    updatedAt
    deletedAt
    user {
      id
      name
    }
  }
}
    `;
export const UnityFragmentDoc = gql`
    fragment Unity on Unity {
  id
  name
  status
  countryId
  country {
    id
    name
    code
  }
  createdAt
  updatedAt
  deletedAt
  userCreated {
    ...User
  }
  userUpdated {
    ...User
  }
  userDeleted {
    ...User
  }
  user {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const EnumTypeFragmentDoc = gql`
    fragment EnumType on EnumType {
  id
  type
  value
  description
  detail
  createdAt
  updatedAt
  deletedAt
}
    `;
export const TerminationFormQuestionAnswerFragmentDoc = gql`
    fragment TerminationFormQuestionAnswer on TerminationFormQuestionAnswer {
  answerOrder
  createdAt
  deletedAt
  description
  id
  isAnswersSelected
  text
  updatedAt
}
    `;
export const TerminationFormSolicitationAnswerFragmentDoc = gql`
    fragment TerminationFormSolicitationAnswer on TerminationFormSolicitationAnswer {
  answerText
  createdAt
  deletedAt
  id
  updatedAt
}
    `;
export const TerminationFormQuestionFragmentDoc = gql`
    fragment TerminationFormQuestion on TerminationFormQuestion {
  createdAt
  deletedAt
  description
  multipleSelection
  id
  questionOrder
  questionStep
  terminationFormAnswerText
  terminationFormQuestionAnswer {
    ...TerminationFormQuestionAnswer
  }
  terminationFormSolicitationAnswer {
    ...TerminationFormSolicitationAnswer
  }
  text
  type
  updatedAt
}
    ${TerminationFormQuestionAnswerFragmentDoc}
${TerminationFormSolicitationAnswerFragmentDoc}`;
export const TerminationFormDtoFragmentDoc = gql`
    fragment TerminationFormDto on TerminationFormDto {
  userAreaOfActivity
  userJobRole
  userName
  userRe
  userTerminationDate
  solicitationId
  terminationFormQuestion {
    ...TerminationFormQuestion
  }
}
    ${TerminationFormQuestionFragmentDoc}`;
export const UserNotificationDtoFragmentDoc = gql`
    fragment UserNotificationDto on UserNotificationDto {
  total
  totalUnread
  notifications {
    id
    relationId
    title
    status
    message
    isRead
    readAt
    createdAt
    updatedAt
    deletedAt
  }
}
    `;
export const JobRolesDocument = gql`
    query jobRoles {
  jobRoles {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JobRolesGQL extends Apollo.Query<JobRolesQuery, JobRolesQueryVariables> {
    document = JobRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListUnityDocument = gql`
    query listUnity {
  listUnity {
    id
    name
    countryId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListUnityGQL extends Apollo.Query<ListUnityQuery, ListUnityQueryVariables> {
    document = ListUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EnumByTypeDocument = gql`
    query enumByType($input: String!) {
  enumByType(type: $input) {
    ...EnumType
  }
}
    ${EnumTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EnumByTypeGQL extends Apollo.Query<EnumByTypeQuery, EnumByTypeQueryVariables> {
    document = EnumByTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountriesDocument = gql`
    query countries {
  countries {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CountriesGQL extends Apollo.Query<CountriesQuery, CountriesQueryVariables> {
    document = CountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountryByIdDocument = gql`
    query countryById($id: String!) {
  countryById(id: $id) {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CountryByIdGQL extends Apollo.Query<CountryByIdQuery, CountryByIdQueryVariables> {
    document = CountryByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCountryDocument = gql`
    mutation createCountry($input: CreateCountryInput!) {
  createCountry(data: $input) {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCountryGQL extends Apollo.Mutation<CreateCountryMutation, CreateCountryMutationVariables> {
    document = CreateCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCountryDocument = gql`
    mutation updateCountry($input: UpdateCountryInput!) {
  updateCountry(data: $input) {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCountryGQL extends Apollo.Mutation<UpdateCountryMutation, UpdateCountryMutationVariables> {
    document = UpdateCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCountryDocument = gql`
    mutation deleteCountry($id: String!) {
  deleteCountry(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCountryGQL extends Apollo.Mutation<DeleteCountryMutation, DeleteCountryMutationVariables> {
    document = DeleteCountryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ColorRaceDashboardDocument = gql`
    query colorRaceDashboard($data: SearchDashboardInput!) {
  colorRaceDashboard(data: $data) {
    type
    value
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ColorRaceDashboardGQL extends Apollo.Query<ColorRaceDashboardQuery, ColorRaceDashboardQueryVariables> {
    document = ColorRaceDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AffirmativeAgreementDashboardDocument = gql`
    query affirmativeAgreementDashboard($data: SearchDashboardInput!) {
  affirmativeAgreementDashboard(data: $data) {
    type
    value
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AffirmativeAgreementDashboardGQL extends Apollo.Query<AffirmativeAgreementDashboardQuery, AffirmativeAgreementDashboardQueryVariables> {
    document = AffirmativeAgreementDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TerminationReasonsDocument = gql`
    query terminationReasons {
  terminationReasons {
    id
    name
    terminationFormType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TerminationReasonsGQL extends Apollo.Query<TerminationReasonsQuery, TerminationReasonsQueryVariables> {
    document = TerminationReasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VoluntaryDashboardDocument = gql`
    query voluntaryDashboard($data: SearchDashboardInput!) {
  voluntaryDashboard(data: $data) {
    type
    percentage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VoluntaryDashboardGQL extends Apollo.Query<VoluntaryDashboardQuery, VoluntaryDashboardQueryVariables> {
    document = VoluntaryDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoluntaryDashboardDocument = gql`
    query involuntaryDashboard($data: SearchDashboardInput!) {
  involuntaryDashboard(data: $data) {
    type
    percentage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoluntaryDashboardGQL extends Apollo.Query<InvoluntaryDashboardQuery, InvoluntaryDashboardQueryVariables> {
    document = InvoluntaryDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenderIdentityDashboardDocument = gql`
    query genderIdentityDashboard($data: SearchDashboardInput!) {
  genderIdentityDashboard(data: $data) {
    man {
      type
      cisgender
      transgender
    }
    woman {
      type
      cisgender
      transgender
    }
    nonBinary
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenderIdentityDashboardGQL extends Apollo.Query<GenderIdentityDashboardQuery, GenderIdentityDashboardQueryVariables> {
    document = GenderIdentityDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NpsDashboardDocument = gql`
    query npsDashboard($data: SearchDashboardInput!) {
  npsDashboard(data: $data) {
    valueNPS
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NpsDashboardGQL extends Apollo.Query<NpsDashboardQuery, NpsDashboardQueryVariables> {
    document = NpsDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardPageDocument = gql`
    query DashboardPage($data: SearchDashboardInput!) {
  colorRaceDashboard(data: $data) {
    type
    value
  }
  npsDashboard(data: $data) {
    valueNPS
  }
  affirmativeAgreementDashboard(data: $data) {
    type
    value
  }
  voluntaryDashboard(data: $data) {
    type
    percentage
  }
  involuntaryDashboard(data: $data) {
    type
    percentage
  }
  involuntaryDashboard(data: $data) {
    type
    percentage
  }
  genderIdentityDashboard(data: $data) {
    man {
      type
      cisgender
      transgender
    }
    woman {
      type
      cisgender
      transgender
    }
    nonBinary
  }
  pcdSolicitationsDashboard(data: $data) {
    qtdIsNotPCD
    qtdIsPCD
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardPageGQL extends Apollo.Query<DashboardPageQuery, DashboardPageQueryVariables> {
    document = DashboardPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTerminationFormDocument = gql`
    query getTerminationForm($solicitationId: String!) {
  getTerminationForm(solicitationId: $solicitationId) {
    ...TerminationFormDto
  }
}
    ${TerminationFormDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTerminationFormGQL extends Apollo.Query<GetTerminationFormQuery, GetTerminationFormQueryVariables> {
    document = GetTerminationFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidTokenTerminationFormDocument = gql`
    query validTokenTerminationForm($expirationToken: String!) {
  validTokenTerminationForm(expirationToken: $expirationToken) {
    ...TerminationFormDto
  }
}
    ${TerminationFormDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidTokenTerminationFormGQL extends Apollo.Query<ValidTokenTerminationFormQuery, ValidTokenTerminationFormQueryVariables> {
    document = ValidTokenTerminationFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveTerminationFormAnswersDocument = gql`
    mutation saveTerminationFormAnswers($data: [TerminationFormAnswerDto!]!, $solicitationId: String!, $origin: String!) {
  saveTerminationFormAnswers(
    data: $data
    solicitationId: $solicitationId
    origin: $origin
  ) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveTerminationFormAnswersGQL extends Apollo.Mutation<SaveTerminationFormAnswersMutation, SaveTerminationFormAnswersMutationVariables> {
    document = SaveTerminationFormAnswersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationsByUserDocument = gql`
    query notificationsByUser {
  notificationsByUser {
    ...UserNotificationDto
  }
}
    ${UserNotificationDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationsByUserGQL extends Apollo.Query<NotificationsByUserQuery, NotificationsByUserQueryVariables> {
    document = NotificationsByUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReadNotificationDocument = gql`
    mutation readNotification($notificationId: String!) {
  readNotification(notificationId: $notificationId) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReadNotificationGQL extends Apollo.Mutation<ReadNotificationMutation, ReadNotificationMutationVariables> {
    document = ReadNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReadAllNotificationsDocument = gql`
    mutation readAllNotifications {
  readAllNotifications {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReadAllNotificationsGQL extends Apollo.Mutation<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables> {
    document = ReadAllNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteNotificationDocument = gql`
    mutation deleteNotification($notificationId: String!) {
  deleteNotification(notificationId: $notificationId) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteNotificationGQL extends Apollo.Mutation<DeleteNotificationMutation, DeleteNotificationMutationVariables> {
    document = DeleteNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAllNotificationsDocument = gql`
    mutation deleteAllNotifications {
  deleteAllNotifications {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAllNotificationsGQL extends Apollo.Mutation<DeleteAllNotificationsMutation, DeleteAllNotificationsMutationVariables> {
    document = DeleteAllNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllSolicitationCardsDocument = gql`
    query searchAllSolicitationCards($input: SearchSolicitationCardInput!) {
  searchAllSolicitationCards(data: $input) {
    ...SolicitationStepGroupedDto
  }
}
    ${SolicitationStepGroupedDtoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllSolicitationCardsGQL extends Apollo.Query<SearchAllSolicitationCardsQuery, SearchAllSolicitationCardsQueryVariables> {
    document = SearchAllSolicitationCardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllSolicitationListDocument = gql`
    query searchAllSolicitationList($input: SearchSolicitationListInput!) {
  searchAllSolicitationList(data: $input) {
    ...SolicitationPage
  }
}
    ${SolicitationPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllSolicitationListGQL extends Apollo.Query<SearchAllSolicitationListQuery, SearchAllSolicitationListQueryVariables> {
    document = SearchAllSolicitationListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnitiesDocument = gql`
    query unities($input: SearchUnityInput!) {
  unities(data: $input) {
    ...UnityPage
  }
}
    ${UnityPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UnitiesGQL extends Apollo.Query<UnitiesQuery, UnitiesQueryVariables> {
    document = UnitiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSolicitationDocument = gql`
    mutation createSolicitation($input: CreateSolicitationInput!) {
  createSolicitation(data: $input) {
    ...Solicitation
  }
}
    ${SolicitationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSolicitationGQL extends Apollo.Mutation<CreateSolicitationMutation, CreateSolicitationMutationVariables> {
    document = CreateSolicitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSolicitationDocument = gql`
    mutation updateSolicitation($input: UpdateSolicitationInput!) {
  updateSolicitation(data: $input) {
    ...Solicitation
  }
}
    ${SolicitationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSolicitationGQL extends Apollo.Mutation<UpdateSolicitationMutation, UpdateSolicitationMutationVariables> {
    document = UpdateSolicitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSolicitationDocument = gql`
    mutation deleteSolicitation($id: String!) {
  deleteSolicitation(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSolicitationGQL extends Apollo.Mutation<DeleteSolicitationMutation, DeleteSolicitationMutationVariables> {
    document = DeleteSolicitationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendNotInitiatedStepDocument = gql`
    mutation sendNotInitiatedStep($input: SendNotInitiatedStepInput!) {
  sendNotInitiatedStep(data: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SendNotInitiatedStepGQL extends Apollo.Mutation<SendNotInitiatedStepMutation, SendNotInitiatedStepMutationVariables> {
    document = SendNotInitiatedStepDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendTerminationFormDocument = gql`
    mutation resendTerminationForm($solicitationId: String!) {
  resendTerminationForm(solicitationId: $solicitationId) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendTerminationFormGQL extends Apollo.Mutation<ResendTerminationFormMutation, ResendTerminationFormMutationVariables> {
    document = ResendTerminationFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveHrOpinionStepDocument = gql`
    mutation saveHrOpinionStep($input: SaveHrOpinionStepInput!) {
  saveHrOpinionStep(data: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveHrOpinionStepGQL extends Apollo.Mutation<SaveHrOpinionStepMutation, SaveHrOpinionStepMutationVariables> {
    document = SaveHrOpinionStepDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendCompletedHrOpinionStepDocument = gql`
    mutation sendCompletedHrOpinionStep($input: SaveHrOpinionStepInput!) {
  sendCompletedHrOpinionStep(data: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SendCompletedHrOpinionStepGQL extends Apollo.Mutation<SendCompletedHrOpinionStepMutation, SendCompletedHrOpinionStepMutationVariables> {
    document = SendCompletedHrOpinionStepDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUnityDocument = gql`
    mutation createUnity($input: CreateUnityInput!) {
  createUnity(data: $input) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUnityGQL extends Apollo.Mutation<CreateUnityMutation, CreateUnityMutationVariables> {
    document = CreateUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUnityDocument = gql`
    mutation updateUnity($input: UpdateUnityInput!) {
  updateUnity(data: $input) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUnityGQL extends Apollo.Mutation<UpdateUnityMutation, UpdateUnityMutationVariables> {
    document = UpdateUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUnityDocument = gql`
    mutation deleteUnity($id: String!) {
  deleteUnity(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUnityGQL extends Apollo.Mutation<DeleteUnityMutation, DeleteUnityMutationVariables> {
    document = DeleteUnityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    mutation login($data: AuthInput!) {
  login(data: $data) {
    ...AuthType
  }
}
    ${AuthTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserGQL extends Apollo.Query<CurrentUserQuery, CurrentUserQueryVariables> {
    document = CurrentUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersDocument = gql`
    query users($data: SearchUserInput!) {
  users(data: $data) {
    currentPage
    nextPage
    pageSize
    previousPage
    totalCount
    totalPage
    results {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersGQL extends Apollo.Query<UsersQuery, UsersQueryVariables> {
    document = UsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation createUser($data: CreateUserInput!) {
  createUser(data: $data) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation updateUser($data: UpdateUserInput!) {
  updateUser(data: $data) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserDocument = gql`
    mutation deleteUser($id: String!) {
  deleteUser(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserGQL extends Apollo.Mutation<DeleteUserMutation, DeleteUserMutationVariables> {
    document = DeleteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }